import { useEffect, useState, useRef } from "react";
import noImage from "../images/clicktoAdd.png";
import { CloseIcon } from "./Icons";

export default function CustomImage(props) {
  const [url, setUrl] = useState(props.src);
  const [isShown, setIsShown] = useState(false);

  //   const hoverTimeOut = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setUrl(props.src);
    }, 2000);
  }, [props.src]);

  const handleMouseLeave = () => {
    // clearTimeout(hoverTimeOut.current);
    setIsShown(false);
  };

  const handleMouseOver = () => {
    // hoverTimeOut.current = setTimeout(() => {
    setIsShown(true);
    // }, 5000);
  };

  //   useEffect(() => {
  //     return () => clearTimeout(hoverTimeOut.current);
  //   }, []);
  const isValidImage = url && url.trim() !== "";
  return (
    <>
      {isShown && isValidImage && (
        <div className="full-screen">
          <div className="img-tooltip card">
            <div
              className="img-tooltip-toggle"
              onClick={() => setIsShown(false)}
            >
              <CloseIcon />
            </div>
            <img
              src={url}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImage;
              }}
              onMouseLeave={() => setIsShown(false)}
            />
          </div>
        </div>
      )}

      <img
        src={url}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        // onMouseEnter={handleMouseOver}
        // onMouseOver={handleMouseOver}
        // onMouseLeave={handleMouseLeave}
        onClick={() => setIsShown(true)}
        width={props.width || 40}
        height={props.height || 40}
        mode={props.mode || "fit"}
      />
    </>
  );
}
